<template>
  <IQOS :title="$t('integrations.supported.title')">
    <p class="c-white">
      {{$t('integrations.supported.you_can_connect')}}
    <br />{{$t('integrations.supported.currently_supported')}}
    </p>
    <div class="supported-integrations">
      <a href="/api/poster/start">
        <img class="poster-logo" src="https://dev.joinposter.com/img/poster-icon.png" alt />
      </a>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

export default {
  components: {
    IQOS
  }
};
</script>

<style scoped>
.supported-integrations {
    margin-top: 3vh;
}

.poster-logo {
    width: 5vw;
}
</style>